import { scrollToElement } from 'src/app/shared/utilities/utils';
import { Component, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

export enum StyleOptionDropdown {
  NORMAL = "NORMAL",
  ADDRESS_CENTER = "ADDRESS_CENTER"

}

@Component({
  selector: 'app-dropdown-select',
  templateUrl: './dropdown-select.component.html',
  styleUrls: ['./dropdown-select.component.scss']
})
export class DropdownSelectComponent {
  UniqueId: string = uuidv4();

  @Input()
  DataArray: any[] | undefined = [];

  @Input()
  KeyName: string[] = [];

  @Input()
  KeyId: string = "";

  @Input()
  SelectedObject: any;

  @Input()
  TranslateKey: string = "";

  @Input()
  Placeholder: string = "";

  @Input()
  Loading: boolean = false

  @Input()
  Error: boolean = false;

  @Input()
  ShowAbsolute: boolean = true;

  @Input() useIdAsModel: boolean = false; // New: use when only the selected item's ID is provided, not the full object

  @Input()
  styleOption: StyleOptionDropdown = StyleOptionDropdown.NORMAL;

  @Input() ScrollParentId: string = ""

  @Input() ScrollChildId: string = ""

  @Input() disabled: boolean = false;

  @Output()
  optionEmitter = new EventEmitter();

  OpenDropdown = false;
  StyleOptionDropdown = StyleOptionDropdown;

  private isFirstChange = true;

  selectedItem: any = null;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setLoadingStatus()
    // if (!changes['DataArray']?.firstChange) {
    //   this.setOtherOptionData();
    // }

    if (this.DataArray && this.SelectedObject !== undefined) {
      this.selectedItem = this.useIdAsModel
        ? this.DataArray.find(item => item[this.KeyId] === this.SelectedObject) || null
        : this.SelectedObject;
    }
  }

  setLoadingStatus() {
    if (this.Loading) {
      this.OpenDropdown = false;
    }
  }

  toggleDropdown() {
    if (!this.Loading && !this.disabled) {
      this.OpenDropdown = !this.OpenDropdown;
    }
    if (this.OpenDropdown) this.scrollElementIntoView();
  }

  selectOption(option: any) {
    const output = this.useIdAsModel ? option[this.KeyId] : option;
    this.optionEmitter.emit(output);
    this.OpenDropdown = false;
  }

  isSelected(item: any): boolean {
    if (!this.SelectedObject) return false;
    if (this.useIdAsModel) {
      return this.SelectedObject === item[this.KeyId];
    }
    return this.SelectedObject?.[this.KeyId] === item[this.KeyId];
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;

    // Verifica si el clic ocurrió dentro del dropdown usando el id único
    const element = document.getElementById(`${this.UniqueId}`);

    if (element && !element.contains(targetElement)) {
      this.OpenDropdown = false;
    }

  }

  private scrollElementIntoView() {
    if (this.ScrollParentId && this.ScrollChildId)
      scrollToElement(this.ScrollParentId, this.ScrollChildId)
  }
}
